const getMessage = (error: unknown): string => {
  if (error instanceof Error) {
    return error.message;
  }

  if (error && typeof error === 'object' && 'message' in error) {
    return String((error as { message: unknown }).message);
  }

  if (typeof error === 'string') {
    return error;
  }

  return JSON.stringify(error);
};

export const errorUtils = {
  getMessage,
};
